const ConnectionContainer = () => import(/* webpackChunkName: "ConnectionContainer" */ "../etl/ConnectionContainer.vue")
const ConnectionDashboard = () => import(/* webpackChunkName: "ConnectionDashboard" */ "../etl/ConnectionDashboard.vue")
const WorkflowDashboard = () => import(/* webpackChunkName: "WorkflowDashboard" */ "../etl/WorkflowDashboard.vue")
const WorkflowEditor = () => import(/* webpackChunkName: "WorkflowForm" */ "../etl/components/workflow/WorkflowEditor.vue")
const TransformationBuilder = () => import(/* webpackChunkName: "TransformationBuilder" */ "../etl/TransformationBuilder.vue")
const ValueMappingSetDashboard = () => import(/* webpackChunkName: "ValueMappingSetDashboard" */ "../etl/ValueMappingSetDashboard.vue")
const ValueMappingSetForm = () => import(/* webpackChunkName: "ValueMappingSetForm" */ "../etl/ValueMappingSetForm.vue")
const EtlInvite = () => import(/* webpackChunkName: "InviteStepper" */ "../etl/EtlInvite.vue")
const WorkflowRunDashboard = () => import(/* webpackChunkName: "RunHistoryDashboard" */ "../etl/WorkflowRunDashboard.vue")

const etlMeta = {
  requiresAuth: true,
  requiresAdmin: false,
  requiresEtlView: true
}

export const routes = [
  {
    path: "/etl/workflows",
    name: "workflows",
    component: WorkflowDashboard,
    meta: etlMeta,
  },
  {
    path: "/etl/workflows/:workflowId(\\d+)",
    name: "workflow-edit",
    component: WorkflowEditor,
    meta: etlMeta,
  },
  {
    path: "/etl/workflows/:workflowId(\\d+)/transformations",
    name: "workflow-transformations",
    component: TransformationBuilder,
    meta: etlMeta,
  },
  {
    path: "/etl/connections",
    name: "connections",
    component: ConnectionDashboard,
    meta: etlMeta,
  },
  {
    path: "/etl/connections/create",
    name: "connection-create",
    component: ConnectionContainer,
    meta: etlMeta,
  },
  {
    path: "/etl/connections/:configId(\\d+)",
    name: "connection-edit",
    component: ConnectionContainer,
    meta: etlMeta,
  },
  {
    path: "/etl/value-mappings",
    name: "value-mappings",
    component: ValueMappingSetDashboard,
    meta: etlMeta,
  },
  {
    path: "/etl/value-mappings/:id(\\d+)",
    name: "value-mappings-form",
    component: ValueMappingSetForm,
    meta: etlMeta,
  },
  {
    path: "/etl/invite",
    name: "etl-invite",
    component: EtlInvite,
    meta: {
      ...etlMeta,
      requiresStaffAdmin: true
    },
  },
  {
    path: '/etl/runs',
    name: "etl-runs",
    component: WorkflowRunDashboard,
    meta: etlMeta,
  }
]
